/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missing_Items_Credit_NoteInputs */

const en_missing_items_credit_note = /** @type {(inputs: Missing_Items_Credit_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A credit note`)
};

/**
* | output |
* | --- |
* | "A credit note" |
*
* @param {Missing_Items_Credit_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const missing_items_credit_note = /** @type {((inputs?: Missing_Items_Credit_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Items_Credit_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_missing_items_credit_note(inputs)
});